import { Component, OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { DropdownHttpService } from '@core/services/dropdown-http.service';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { WebDisplayDataService } from '../web-display/services/web-display-data.service';
import { tap, catchError } from 'rxjs/operators';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { WebDisplayEditDialogComponent } from '../web-display/dialogs/web-display-edit.component';
import Swal from "sweetalert2";
import { AppPermissionService } from '@core/services/app-permission.service';
@Component({
  selector: 'mobile-display',
  templateUrl: './mobile-display.component.html',
  styleUrls: ['./mobile-display.component.scss']
})

export class MobileDisplayComponent implements OnInit, OnDestroy {

  form: FormGroup;
  messages$ = this.webDisplayDataService.messages$;
  mobileDisplays =[];

  merchantList = this.dropdownHttpService.merchantSites;
  activeTab = 0;
  
  type = 1 ; // mobile type
  getmerchant: any;
  currentMerchantID : number;
  loading = false;
  searchBtnLoading = false;
  clearBtnLoading = false;
  dataLength = 0;
  params = '';
  buttonLoading = true;
  checkValidation = false;
  refreshStatus: boolean;
  initialValues:any;
  listControl:any;

  // permissions
  canEditMobileDisplayPosition: boolean;
  canViewMobileDisplaySettings: boolean;
  canUpdateMobileDisplayStatus: boolean;

  private subscription = new Subscription();
  private subscriptions = new Subscription();
  private refreshSubcription = new Subscription();

  constructor(
    private dropdownHttpService: DropdownHttpService,
    private loadingBar: LoadingBarService,
    private webDisplayDataService:WebDisplayDataService,
    private cdr: ChangeDetectorRef,
    public dialog: MatDialog,
    private appPermissionService: AppPermissionService,
  ) { }

  ngOnInit(): void {
    this.dropdownHttpService.merchantSites.subscribe(res => {
      this.getmerchant =  res;
      this.currentMerchantID = this.getmerchant[this.activeTab]['id'];
    });
    this.formInit();

    const apSub = this.appPermissionService.getAppPermissions().subscribe(appPermissions => {
      this.canEditMobileDisplayPosition = appPermissions.edit_mobile_display_position;
      this.canViewMobileDisplaySettings = appPermissions.view_mobile_display_settings;
      this.canUpdateMobileDisplayStatus = appPermissions.update_mobile_display_status;
    });

    this.subscriptions.add(apSub);
  }

  onSelectTab($event) {
    this.activeTab = $event.index;
    this.currentMerchantID = this.getmerchant[this.activeTab]['id'];
    this.onSubmit(this.currentMerchantID);
  }

  onSubmit($merchant_id) {
    this.formInit();
    this.loading = true;
    const data = {};
    data['type']        = this.type;
    data['merchant_id'] = $merchant_id;
    this.mobileDisplays =[];
    Object.keys(data).forEach((key) => (data[key] == null || data[key] === '') && delete data[key]);
    this.params = Object.keys(data).map(key => key + '=' + data[key]).join('&');
    const parameters = this.params ? `&${this.params}` : '';
    this.loadingBar.start();
    this.webDisplayDataService.getWithQuery(`?${parameters}`).subscribe(res => {
        this.mobileDisplays = res;
        this.dataLength = this.mobileDisplays.length;
        this.loading = false;
        this.clearBtnLoading = false;
        this.searchBtnLoading = false;
        this.loadingBar.complete();
        this.buttonLoading = false;
        this.addFooterSectionMerchantForm();
        this.cdr.detectChanges();
    });
  }

  onOpenDialog(rows?: any) { 
    const webDisplayData = this.webDisplayDataService.getById(rows.id);
        this.subscription = webDisplayData.pipe(
          tap((res) => {
            this.openDialogBy(WebDisplayEditDialogComponent, { rows: res });
          })
        ).subscribe();
  }

  private openDialogBy(componentRef: any, data?: { mode?: string, rows?: any }) {
    const dialogRef = this.dialog.open(componentRef, {
      width: '800px',
      data: {
        rows: data.rows,
        mode: data.mode
      }
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result === true){
        this.refreshStatus = true;
        this.reload();
      }
    });
    
  }

  reload() {
    if (this.refreshStatus === true) {
      this.onSubmit(this.currentMerchantID);
    }
    this.buttonLoading = false;
  }

  onSave(){
    this.buttonLoading = true;
   
    const data = {
      ...this.form.value
    };
    const arrangement = [];
    Object.keys(data.footer_section_merchant).forEach((key) => {
      if( data.footer_section_merchant[key].mobile_row == null && data.footer_section_merchant[key].mobile_row == '') data.footer_section_merchant[key].mobile_row = 0;
      if( data.footer_section_merchant[key].mobile_column == null && data.footer_section_merchant[key].mobile_column == '') data.footer_section_merchant[key].mobile_column = 0;
      
      if(data.footer_section_merchant[key].mobile_row > 0){
        arrangement.push(data.footer_section_merchant[key].mobile_row);
      }
      
    });

    data['type'] = this.type;
   
    // here to rearrange row
    const removeDuplite = new Set(arrangement);
    var sortedArrangement = Array.from(removeDuplite).sort();
   
    for (let i = 0; i < sortedArrangement.length; i++) {
      Object.keys(data.footer_section_merchant).forEach((key) => {
        if(data.footer_section_merchant[key].mobile_row == sortedArrangement[i]){
          data.footer_section_merchant[key].mobile_row = i + 1;
        }
      });
    }
    
    if (this.form.valid) {
      this.form.setErrors({ 'invalid': true });
      this.webDisplayDataService.updateDisplay(data).subscribe((res => {
          this.webDisplayDataService.messages$
          this.buttonLoading = false;
 
            // To enable "Save" button after get response
          this.form.setErrors(null);
          this.cdr.detectChanges();
          // this.refreshStatus = true;
          setTimeout(()=>{this.onSubmit(this.currentMerchantID);}, 1000);

          }),
          catchError((error) => {
            this.webDisplayDataService.messages$
            this.buttonLoading = false;
            // To enable "Save" button after get response
 
            this.form.setErrors(null);
            this.form.enable();
            this.cdr.detectChanges();
            throw error;
          })
        );
    }
    this.buttonLoading = false;
  }

  private formInit() {
    this.form = new FormGroup({
      type: new FormControl(this.type)
    });
    
  }

  private addFooterSectionMerchantForm(){
    const buildSubDetails = () => {
      let contents = {};
      this.mobileDisplays.map((element, index) => {
        const min = element.mobile == 1 ? 1 : 0;
        const contentsGroup = new FormGroup({
          footer_section_merchant_id: new FormControl(element.id),
          mobile: new FormControl(element.mobile),
          mobile_row: new FormControl(element.mobile_row,[Validators.required,Validators.min(min),Validators.pattern("^[0-9]*$")]),
          mobile_column: new FormControl(element.mobile_column, [Validators.required,Validators.min(min),Validators.max(2),Validators.pattern("^[0-9]*$")]),
        });
        contents = { ...contents, [index]: contentsGroup };
      });
      return contents;
    };
    this.form.addControl('footer_section_merchant', new FormGroup(buildSubDetails()));  
    this.initialValues = this.form.value;
    this.reset();
  } 

  reset(){
    this.form.reset(this.initialValues);
  }

  onToggleStatus(row: any, index: any){

    let message = '';
    let duplicate = false;
  
    let mobile_row = this.form.get('footer_section_merchant.'+index+'.mobile_row').value;
    let mobile_column = this.form.get('footer_section_merchant.'+index+'.mobile_column').value;

    if(mobile_row > 0 && mobile_column > 0){

      Object.keys(this.form.get('footer_section_merchant').value).forEach(key => {
        if ( key != index && this.form.get('footer_section_merchant.'+key+'.mobile_row').value == mobile_row && this.form.get('footer_section_merchant.'+key+'.mobile_column').value == mobile_column && this.form.get('footer_section_merchant.'+key+'.mobile').value == 1) {
          duplicate = true;
          message = `Unable to update due to duplicate found. Please check the position again`;
          const ele = document.getElementById(row.id) as HTMLInputElement;
          ele.checked = false;
        }
      });
  
    }
    if(duplicate){
      Swal.fire({
        text: message,
        icon: 'warning',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        reverseButtons: true,
      }).then((result) => {
  
      });
    }else{
      const data = {
        type:this.type,
        footer_section_merchant_id: row.id,
        mobile: row.mobile == 1 ? 0 : 1
      };
      this.webDisplayDataService.updateStatus(data).subscribe(() =>{
        this.messages$ = this.webDisplayDataService.messages$
        this.refreshStatus = true;
      }
      );
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.subscriptions.unsubscribe();
    this.refreshSubcription.unsubscribe();
    this.reload();
  }

  findDuplicate(index){

    let mobile_row = this.form.get('footer_section_merchant.'+index+'.mobile_row').value;
    let mobile_column = this.form.get('footer_section_merchant.'+index+'.mobile_column').value;
    let mobile = this.form.get('footer_section_merchant.'+index+'.mobile').value;

    let duplicate = false;
    if(mobile == 1){
      if(mobile_row > 0 && mobile_column > 0){

        Object.keys(this.form.get('footer_section_merchant').value).forEach(key => {
          if ( key != index && this.form.get('footer_section_merchant.'+key+'.mobile_row').value == mobile_row && this.form.get('footer_section_merchant.'+key+'.mobile_column').value == mobile_column && this.form.get('footer_section_merchant.'+key+'.mobile').value == 1) {
            this.form.get('footer_section_merchant.'+key+'.mobile_row').setErrors({'duplicate': true});
            this.form.get('footer_section_merchant.'+key+'.mobile_column').setErrors({'duplicate': true});
            this.form.get('footer_section_merchant.'+index+'.mobile_row').setErrors({'duplicate': true});
            this.form.get('footer_section_merchant.'+index+'.mobile_column').setErrors({'duplicate': true});
            duplicate = true;
          }else if(key != index && (this.form.get('footer_section_merchant.'+key+'.mobile_row').value !== mobile_row || this.form.get('footer_section_merchant.'+key+'.mobile_column').value !== mobile_column && this.form.get('footer_section_merchant.'+key+'.mobile').value == 1)){
          
            if(duplicate == false){
  
              if (this.form.get('footer_section_merchant.'+index+'.mobile_row').hasError('duplicate')) {
                delete this.form.get('footer_section_merchant.'+index+'.mobile_row').errors['duplicate'];
                this.form.get('footer_section_merchant.'+index+'.mobile_row').updateValueAndValidity();
              }
  
              if (this.form.get('footer_section_merchant.'+index+'.mobile_column').hasError('duplicate')) {
                delete this.form.get('footer_section_merchant.'+index+'.mobile_column').errors['duplicate'];
                this.form.get('footer_section_merchant.'+index+'.mobile_column').updateValueAndValidity();
              }
  
            }
  
            if (this.form.get('footer_section_merchant.'+key+'.mobile_row').hasError('duplicate')) {
              delete this.form.get('footer_section_merchant.'+key+'.mobile_row').errors['duplicate'];
              this.form.get('footer_section_merchant.'+key+'.mobile_row').updateValueAndValidity();
            }
    
            if (this.form.get('footer_section_merchant.'+key+'.mobile_column').hasError('duplicate')) {
              delete this.form.get('footer_section_merchant.'+key+'.mobile_column').errors['duplicate'];
              this.form.get('footer_section_merchant.'+key+'.mobile_column').updateValueAndValidity();
            }
            
          }
        });
      }else{
        Object.keys(this.form.get('footer_section_merchant').value).forEach(key => {
  
          if (this.form.get('footer_section_merchant.'+key+'.mobile_row').hasError('duplicate')) {
            delete this.form.get('footer_section_merchant.'+key+'.mobile_row').errors['duplicate'];
            this.form.get('footer_section_merchant.'+key+'.mobile_row').updateValueAndValidity();
          }
  
          if (this.form.get('footer_section_merchant.'+key+'.mobile_column').hasError('duplicate')) {
            delete this.form.get('footer_section_merchant.'+key+'.mobile_column').errors['duplicate'];
            this.form.get('footer_section_merchant.'+key+'.mobile_column').updateValueAndValidity();
          }
  
        });
      }
    }
  }

}

